import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/img/logo.svg';
import _imports_1 from '@/img/logo-mobile.svg';
import _imports_2 from '@/img/icon/arrow-down.svg';
import _imports_3 from '@/img/icon/country.svg';
import _imports_4 from '@/img/icon/tel.svg';
import _imports_5 from '@/img/icon/bell.svg';
import _imports_6 from '@/img/icon/heart.svg';
import _imports_7 from '@/img/icon/person.svg';
const _hoisted_1 = _imports_0;
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "header__inner"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}, [/*#__PURE__*/_createElementVNode("picture", {
  class: "logo-img"
}, [/*#__PURE__*/_createElementVNode("source", {
  srcset: _hoisted_1,
  media: "(min-width: 600px)"
}), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "logo"
})]), /*#__PURE__*/_createElementVNode("button", {
  class: "logo-btn"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "logo-btn__img",
  src: _imports_2,
  alt: "arrow"
})])], -1);
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<nav class=\"menu\"><ul class=\"menu__list\"><li class=\"menu__list-item\"><a class=\"menu__list-link\" href=\"#\"><img class=\"menu__list-img\" src=\"" + _imports_3 + "\" alt=\"country\"> Киев RU </a></li><li class=\"menu__list-item\"><a class=\"menu__list-link\" href=\"#\">Главная</a></li><li class=\"menu__list-item\"><a class=\"menu__list-link\" href=\"#\">Доставка</a></li><li class=\"menu__list-item\"><a class=\"menu__list-link\" href=\"#\">О нас</a></li><li class=\"menu__list-item\"><a class=\"menu__list-link\" href=\"#\">Новости</a></li><li class=\"menu__list-item\"><a class=\"menu__list-link\" href=\"tel: 380976993438\"><img class=\"menu__list-img\" src=\"" + _imports_4 + "\" alt=\"country\"> +38 097 699 34 38 </a></li></ul></nav>", 1);
const _hoisted_7 = {
  class: "header__btns"
};
const _hoisted_8 = {
  class: "header__btn"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "header__btn-img",
  src: _imports_5,
  alt: "icon"
}, null, -1);
const _hoisted_10 = {
  key: 0,
  class: "header__count"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "header__btn-img",
  src: _imports_6,
  alt: "icon"
}, null, -1);
const _hoisted_12 = {
  key: 0,
  class: "header__count"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "header__btn-img",
  src: _imports_7,
  alt: "icon"
}, null, -1);
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Корзина", -1);
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.7 1.4C5.88885 1.14819 6.18524 1 6.5 1H18.5C18.8148 1 19.1111 1.14819 19.3 1.4L22.3 5.4C22.4298 5.5731 22.5 5.78363 22.5 6V20C22.5 20.7957 22.1839 21.5587 21.6213 22.1213C21.0587 22.6839 20.2957 23 19.5 23H5.5C4.70435 23 3.94129 22.6839 3.37868 22.1213C2.81607 21.5587 2.5 20.7957 2.5 20V6C2.5 5.78363 2.57018 5.5731 2.7 5.4L5.7 1.4ZM7 3L4.5 6.33333V20C4.5 20.2652 4.60536 20.5196 4.79289 20.7071C4.98043 20.8946 5.23478 21 5.5 21H19.5C19.7652 21 20.0196 20.8946 20.2071 20.7071C20.3946 20.5196 20.5 20.2652 20.5 20V6.33333L18 3H7Z",
  fill: "white"
}), /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.5 6C2.5 5.44772 2.94772 5 3.5 5H21.5C22.0523 5 22.5 5.44772 22.5 6C22.5 6.55228 22.0523 7 21.5 7H3.5C2.94772 7 2.5 6.55228 2.5 6Z",
  fill: "white"
}), /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.5 9C9.05228 9 9.5 9.44772 9.5 10C9.5 10.7956 9.81607 11.5587 10.3787 12.1213C10.9413 12.6839 11.7044 13 12.5 13C13.2956 13 14.0587 12.6839 14.6213 12.1213C15.1839 11.5587 15.5 10.7956 15.5 10C15.5 9.44772 15.9477 9 16.5 9C17.0523 9 17.5 9.44772 17.5 10C17.5 11.3261 16.9732 12.5979 16.0355 13.5355C15.0979 14.4732 13.8261 15 12.5 15C11.1739 15 9.90215 14.4732 8.96447 13.5355C8.02678 12.5979 7.5 11.3261 7.5 10C7.5 9.44772 7.94772 9 8.5 9Z",
  fill: "white"
})], -1);
const _hoisted_16 = {
  key: 0,
  class: "header__count"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
    to: "/rol-shop/"
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("button", _hoisted_8, [_hoisted_9, $props.notifCount != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($props.notifCount), 1)) : _createCommentVNode("", true)]), _createVNode(_component_router_link, {
    class: "header__btn",
    to: "/rol-shop/profile/favorites"
  }, {
    default: _withCtx(() => [_hoisted_11, $props.favoriteCount != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($props.favoriteCount), 1)) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_router_link, {
    class: "header__btn",
    to: "/rol-shop/profile"
  }, {
    default: _withCtx(() => [_hoisted_13]),
    _: 1
  }), _createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = $event => $setup.drawerOpen ? _ctx.$emit('closeDrawer') : _ctx.$emit('openDrawer')),
    class: _normalizeClass(["header__btn", {
      'is--open': $setup.drawerOpen
    }])
  }, [_hoisted_14, _hoisted_15, $props.cartCount != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($props.cartCount), 1)) : _createCommentVNode("", true)], 2)])])])]);
}